import { useState, useEffect } from "react";
import ApiConstants from "../utils/ApiConstants";

export const usePayableAmount = (authenticatedApiFetch, product, productId, client) => {
  const [payableAmount, setPayableAmount] = useState(null);

  useEffect(() => {
    const fetchPayableAmount = async () => {
      try {
        const apiUrl = `${ApiConstants.BASE_URL}${ApiConstants.getPayableAmount(product, productId, client)}`;
        const response = await authenticatedApiFetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });

        if (response.status === 200 && response.data) {
          setPayableAmount(parseFloat(response.data));
        } else {
          console.error("Error fetching payable amount:", response);
        }
      } catch (error) {
        console.error("Error fetching payable amount:", error);
      }
    };

    fetchPayableAmount();
  }, []); 

  return payableAmount;
};
